<script setup lang="ts">
import {PropType} from "vue";
import {ICellRendererParams} from "ag-grid-community";
import {StringUtils} from "@/utils/common/StringUtils.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import Translator from "@/utils/common/Translator.ts";
import AGGridUtils from "@/utils/UIConstants/AGGridUtils.ts";

const props = defineProps({
  params: {
    type: Object as PropType<ICellRendererParams>,
    required: true
  }
});

const handler = props.params["handler"]();
const fieldValue = props.params.value;
const caption = createItemCaption();
const highlightedHtml = AGGridUtils.getFindHighlightedHtml(props.params.api, props.params.node, props.params.column, fieldValue ?? '');

function createItemCaption() {
  if (!fieldValue)
    return "";
  let text = "";
  let fields: string[] = StringUtils.csvLineToList(fieldValue);
  let idPrefix = NamaCommon.getFieldValue(handler.object, handler.grid.id! + "." + CommonFieldIds.ENTITY_TYPE, props.params.node.rowIndex!);
  if (idPrefix) {
    for (let i = 0; i < fields.length; i++)
      fields[i] = idPrefix + "." + fields[i];
  }
  for (let i = 0; i < fields.length; i++) {
    text += Translator.translateId(fields[i]);
    if (i < fields.length - 1)
      text += ",";
  }
  if (idPrefix + "." + fieldValue === text.toString())
    return fieldValue;
  else
    return text;
}
</script>

<template>
    <q-item v-if="fieldValue" dense class="tw-px-0 tw-w-full tw-h-full">
      <q-item-section>
        <q-item-label>
          <span v-if="highlightedHtml" v-html="highlightedHtml"/>
          <span v-else v-text="fieldValue"/>
        </q-item-label>
        <q-item-label caption class="dark:tw-text-[rgb(255,255,255,0.5)]" v-if="fieldValue !== caption">
          {{ caption }}
        </q-item-label>
      </q-item-section>
    </q-item>
</template>

<style scoped>

</style>
